import React, { useEffect } from 'react'

import { Heading, Select, Stack, Box, Text } from '@chakra-ui/react'
import { Form, useFormikContext } from 'formik'
import { useSelector } from 'react-redux'

import { districtOptions, staffRoles } from '../../../constants'
import { FormField } from '../../ui'

const StaffForm = () => {
  const user = useSelector(state => state.auth.user)

  const { values, initialValues, setFieldValue } = useFormikContext()

  const isTransitionTeam = values.role === 'Transition Team'

  useEffect(() => {
    if (isTransitionTeam) setFieldValue('district', values.role)
    else setFieldValue('district', initialValues.district)
  }, [isTransitionTeam, setFieldValue])

  return (
    <Form>
      <Heading size='md' mb={2}>
        Personal Information
      </Heading>
      <Stack direction={{ base: 'column', md: 'row' }} gap={2}>
        <Stack gap={2} w='100%'>
          <FormField
            field='user.first_name'
            placeholder='First Name *'
            isRequired
          />
          <FormField field='user.middle_name' placeholder='Middle Name' />
          <FormField
            field='user.last_name'
            placeholder='Last Name *'
            isRequired
          />
        </Stack>

        <Stack gap={2} w='100%'>
          <FormField field='user.preferred_name' placeholder='Preferred Name' />
          <FormField field='user.suffix' placeholder='Suffix' />
          <FormField field='user.pronouns' placeholder='Pronouns' />
        </Stack>
      </Stack>

      {user?.is_admin && (
        <Box my={4}>
          <Heading size='md' mb={2}>
            Council Information
          </Heading>

          <Stack>
            <FormField
              field='role'
              options={staffRoles}
              inputType={Select}
              placeholder='Role *'
            />

            <FormField
              field='district'
              placeholder='District *'
              isDisabled={isTransitionTeam}
              options={districtOptions}
              inputType={Select}
            />
            {isTransitionTeam && (
              <Text variant='subheading-sm' align='end'>
                District was automatically set
              </Text>
            )}

            <FormField field='user.email' placeholder='Email *' />
          </Stack>
        </Box>
      )}
    </Form>
  )
}

export default StaffForm
